import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-gutter-y-sm" }

import { AxiosError } from "axios"
import { Subscription } from "rxjs"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxInput from "src/components/input/SfxInput.vue"
import SfxInputPassword from "src/components/input/SfxInputPassword.vue"
import { useAuthStore } from "src/stores/authStore"
import { useTopNavigationStore } from "src/stores/topNavigationStore"
import { Log } from "src/util/classes/log"
import { ContextSource } from "src/util/enums/contextSource"
import { ContextAction } from "src/util/enums/entityType"
import { hashPassword } from "src/util/functions/hashing"
import { helpTourNotImplemented } from "src/util/functions/helpTour"
import { showErrorNotification, showSuccessNotification } from "src/util/functions/notifications"
import { getPasswordRequirements, isIncorrectPassword } from "src/util/functions/user"
import { patchChangePassword } from "src/util/http/springboard/user"
import { computed, onMounted, onUnmounted, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePasswordOverlay',
  emits: ["dialog-ok"],
  setup(__props, { emit: __emit }) {

const emit = __emit

//endregion

//region Variables

const { t } = useI18n()
const authStore = useAuthStore()
const topNavigationStore = useTopNavigationStore()
const currentPassword = ref("")
const newPassword = ref("")
const repeatNewPassword = ref("")
const errorMessage = t("sfxDialogChangePassword.password_mismatch")
let subscription: Subscription

const validDateRule = computed(() => getPasswordRequirements(currentPassword.value))

//endregion

//region Lifecycle

onMounted(() => {
  subscription = topNavigationStore.overlayContextActionClicked.subscribe((contextAction) => {
    if (
      contextAction.source === ContextSource.CHANGE_PASSWORD &&
      contextAction.item.action === ContextAction.HELP
    ) {
      return helpTourNotImplemented("ChangePasswordOverlay")
    }
  })
})

onUnmounted(() => {
  subscription?.unsubscribe()
})

//endregion

//region Functions

async function setNewPassword() {
  if (newPassword.value === repeatNewPassword.value) {
    try {
      const hashResult = await hashPassword(newPassword.value)
      if (hashResult) {
        authStore.setNewPasswordHashed(hashResult)
      } else {
        Log.error({ message: "Failed to hash password." })
      }
    } catch (error) {
      Log.error({ message: "Failed to set new password.", error })
    }
  }
}

async function updatePassword() {
  try {
    await patchChangePassword(
      {},
      {
        current_password: currentPassword.value,
        password: newPassword.value,
      }
    )

    showSuccessNotification(t("sfxDialogChangePassword.password_changed"))
    emit("dialog-ok")
  } catch (error: unknown) {
    if (error instanceof AxiosError && isIncorrectPassword(error)) {
      return showErrorNotification(t("sfxDialogChangePassword.password_incorrect"))
    }
    showErrorNotification(t("sfxErrorMsg.error_change_password"))
    Log.error({ message: "An error occurred while trying to update the password", error })
  }
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createBlock(_component_q_form, {
    onSubmit: updatePassword,
    class: "fit sfx-password-change-form",
    greedy: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(SfxInput, {
          "model-value": '',
          class: "hidden",
          autocomplete: "email"
        }),
        _createVNode(_component_q_card_section, { class: "text-caption text-italic text-field-label q-px-none" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("sfxDialogChangePassword.password_requirements")), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(SfxInputPassword, {
            modelValue: currentPassword.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPassword).value = $event)),
            label: _ctx.$t('sfxDialogChangePassword.input_current_password'),
            autocomplete: "current-password"
          }, null, 8, ["modelValue", "label"]),
          _createVNode(SfxInputPassword, {
            modelValue: newPassword.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newPassword).value = $event)),
            label: _ctx.$t('sfxDialogChangePassword.input_new_password'),
            "lazy-rules": "",
            rules: validDateRule.value,
            autocomplete: "new-password"
          }, null, 8, ["modelValue", "label", "rules"]),
          _createVNode(SfxInputPassword, {
            modelValue: repeatNewPassword.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((repeatNewPassword).value = $event)),
            label: _ctx.$t('sfxDialogChangePassword.input_repetition'),
            "lazy-rules": "",
            rules: [(value) => value === newPassword.value || _unref(errorMessage)],
            "error-message": _unref(errorMessage),
            autocomplete: "new-password"
          }, null, 8, ["modelValue", "label", "rules", "error-message"])
        ])
      ]),
      _createVNode(SfxBtn, {
        class: "q-mt-md sfx-password-change-button",
        label: _ctx.$t('sfxButtons.btn_change_password'),
        disable: !currentPassword.value || !newPassword.value || !repeatNewPassword.value,
        type: "submit",
        onClick: setNewPassword
      }, null, 8, ["label", "disable"])
    ]),
    _: 1
  }))
}
}

})